import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";

import foodImg from "../assets/img/food.png";
import ebookImg from "../assets/img/ebook.png";
import taskImg from "../assets/img/task.png";
import tour from "../assets/img/tour.png";
import portImg from "../assets/img/personal_portfolio.png";

import gymImg from "../assets/img/gym.png";
import restImg from "../assets/img/rest.png";
import musicImg from "../assets/img/music.png";
import parImg from "../assets/img/parallyx.png";
import onlineImg from "../assets/img/online-meal.png";
import landingImg from "../assets/img/landing.png";
import hoobankImg from "../assets/img/hoobank.png";
import threeImg from "../assets/img/3d.png";
import colorSharp2 from "../assets/img/color-sharp2.png";

// import 'animate.css';
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const ReactThreeProjects = [
    {
      title: "3D Web Developer Portfolio",
      description:
        " designed and developed a captivating 3D portfolio website using React.js, showcasing my skills and projects in an immersive and visually stunning online experience.",
      imgUrl: threeImg,
      projLink: "https://3dwebsiteportfolio.netlify.app/",
    },
  ];

  const HtmlProjects = [
    {
      title: "GYM Website",
      description:
        "Elevate your fitness journey with our premier gym facility. Discover a place where wellness meets motivation, and start sculpting the new you today.",
      imgUrl: gymImg,
      projLink: "https://gymrizwi.netlify.app/",
    },
    {
      title: "Restaurant Website",
      description:
        "Indulge your senses in a culinary adventure. Explore our restaurant's delectable menu, a fusion of flavors that promises an unforgettable dining experience.",
      imgUrl: restImg,
      projLink: "https://rizwirestaurant.netlify.app/",
    },
    {
      title: "Music Website",
      description:
        "Immerse yourself in the world of music. Discover a diverse collection of melodies, artists, and genres, all at your fingertips. Let the rhythm guide you.",
      imgUrl: musicImg,
      projLink: "https://musicwebsiter.netlify.app/",
    },
    {
      title: "Parallyx Website",
      description:
        "Experience a captivating journey through stunning visuals and seamless storytelling on our parallax website. Scroll, explore, and be immersed in a dynamic web adventure.",
      imgUrl: parImg,
      projLink: "https://parralyxweb.netlify.app/",
    },
    {
      title: "Online Food Ordering Website",
      description:
        "Satisfy your cravings from the comfort of your home. Browse, order, and enjoy a delicious selection of culinary delights with our online food ordering platform.",
      imgUrl: onlineImg,
      projLink: "https://onlinemealweb.netlify.app/",
    },
    {
      title: "Landing Page",
      description:
        "Welcome to the digital frontier. Our web development landing site is your gateway to limitless online possibilities. Explore, innovate, and create with us.",
      imgUrl: landingImg,
      projLink: "https://devlplandingpage.netlify.app/",
    },
  ];
  const projects = [
    {
      title: "Personal Portfolio",
      description:
        "Experience my journey through code. Explore my portfolio website to witness a collection of web projects that showcase my skills and passion for innovation.",
      imgUrl: portImg,
      projLink: "https://rizwikportfolio.netlify.app/",
    },
    {
      title: "Designer Portfolio",
      description:
        "Crafted a captivating React.js portfolio website to showcase the artistic and design prowess. Explore their creative journey through a stunning collection of visual works and projects.",
      imgUrl: taskImg,
      projLink: "https://portfoliowebsiter.netlify.app/",
    },
    {
      title: "Project HooBank",
      description:
        " designed and developed a responsive Hoobank website using React.js, delivering a user-friendly banking experience with modern design and functionality.",
      imgUrl: hoobankImg,
      projLink: "https://hoobankrwebsite.netlify.app/",
    },
    {
      title: "Food Website",
      description:
        "Satisfy your cravings with ease. Explore our React.js pizza ordering website and enjoy a seamless, mouthwatering experience that brings your favorite slices right to your doorstep.",
      imgUrl: foodImg,
      projLink: "https://foodorderingapplicationr.netlify.app/",
    },
    {
      title: "EBOOK Website",
      description:
        "I built an engaging ebook website using React.js, providing readers with a seamless digital platform to explore and enjoy a wide range of literary content",
      imgUrl: ebookImg,
      projLink: "https://ebookapplicaton.netlify.app/",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Accomplished web developer with two years of experience in
                    developing and maintaining websites. Recognized for
                    leadership and collaborative abilities when working in team
                    settings. Motivated to provide clients with user-friendly
                    applications.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Tab 1</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Tab 2</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tab 3</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <h1
                          style={{ textAlign: "center", paddingBottom: "50px" }}
                        >
                          React JS Projects
                        </h1>
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <h1
                          style={{ textAlign: "center", paddingBottom: "50px" }}
                        >
                          React-Three Js Projects
                        </h1>
                        <Row>
                          {ReactThreeProjects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <h1
                          style={{ textAlign: "center", paddingBottom: "50px" }}
                        >
                          HTML CSS Projects
                        </h1>
                        <Row>
                          {HtmlProjects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
